import styled from 'styled-components';

export const PortalWrapper = styled.div<{ $visible: boolean; $x: number; $y: number }>`
  position: fixed;
  pointer-events: none;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  transition: opacity 0.15s ease-in-out;
  left: ${({ $x }) => $x}px;
  top: ${({ $y }) => $y}px;
`;
